function getCookie(cName) {
  const name = `${cName}=`
  const cDecoded = decodeURIComponent(document.cookie)
  const cArr = cDecoded.split('; ')
  let res
  cArr.forEach((val) => {
    if (val.indexOf(name) === 0)
      res = val.substring(name.length)
  })
  return res
}

export default getCookie
